import { useContext, useEffect } from "react";
import { Box } from "@mui/material";
import { CartContext } from "../../store/context/CartContext";
import { useAuthStore } from "../../store/zustand/authStore";
import NotAllowed from "../NotAllowed/NotAllowed";
import ActiveMembershipsStat from "./components/ActiveMembershipsStat";
import FirstTimeMembersStat from "./components/FirstTimeMembersStat";
import ReturningActiveMembersStat from "./components/ReturningActiveMembersStat";
import ActiveMembershipsByYearStat from "./components/ActiveMembershipsByYearStat";
import ActiveMembershipsByMonthStat from "./components/ActiveMembershipsByMonthStat";
import ActiveMembershipsByDayStat from "./components/ActiveMembershipsByDayStat";

export default function GeneralStatistics() {
  const { setTitleSeccion } = useContext(CartContext);
  const user = useAuthStore((state) => state.user);
  const hasAccess = Boolean(user?.admin_users?.SADMIN?.READ?.[0]);

  useEffect(() => {
    setTitleSeccion("Estadísticas Generales");
  }, [setTitleSeccion]);

  if (!hasAccess) {
    return <NotAllowed user={user} page={"SADMIN"} />;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}>
      <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
        <ActiveMembershipsStat />
        <FirstTimeMembersStat />
        <ReturningActiveMembersStat />
      </Box>
      <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
        <ActiveMembershipsByYearStat />
        <ActiveMembershipsByMonthStat />
      </Box>
      <ActiveMembershipsByDayStat />
    </Box>
  );
}
